module.exports = __webpack_public_path__ + "robotboy_2-197b600ee63f04770a012e45df0e53a2.png";